import { createAction } from 'redux-actions';

import { HOME_SELECTED } from 'app/features/header/actionTypes';

const homeSelected = createAction(HOME_SELECTED);

export { homeSelected };
